import { apiRequest } from "../lib/apiClient";
import type { TenantDomainCreate, TenantDomainOut } from "./types";

/** `backend/app/api/v1/domains.py` — §11.2. Registration + real DNS TXT-record ownership
 * verification are real; live request routing/TLS issuance (§11.3) are not — see that
 * module's docstring. All routes here are OWNER-only except the list, which any
 * authenticated role can read. */

export function listDomains(accessToken: string): Promise<TenantDomainOut[]> {
  return apiRequest<TenantDomainOut[]>("/domains", { accessToken });
}

export function createDomain(accessToken: string, body: TenantDomainCreate): Promise<TenantDomainOut> {
  return apiRequest<TenantDomainOut>("/domains", { method: "POST", accessToken, body });
}

export function verifyDomain(accessToken: string, domainId: string): Promise<TenantDomainOut> {
  return apiRequest<TenantDomainOut>(`/domains/${domainId}/verify`, { method: "POST", accessToken });
}

export function deleteDomain(accessToken: string, domainId: string): Promise<void> {
  return apiRequest<void>(`/domains/${domainId}`, { method: "DELETE", accessToken });
}
